<template>
  <div>
    <transition name="fade">
      <div v-show="end == false" >
        <div id="bg-image"></div>
        <tutorial ></tutorial>
      </div>
    </transition>
    <transition name="fade">
      <div v-show="end == true">
        <header>
          <div id="line"></div>
          <head-box v-bind:alg="algorithm">
            <template v-slot:select>
              <select class="dropdown" v-model="algorithm" >
                <option  hidden>{{ algorithm }}</option>
                <option id="item">Breadth First Search</option>
                <option id="item">Depth First Search</option>
                <option id="item">Dijkstra Algorithm</option>
                <option id="item">Bellman-Ford Algorithm</option>
              </select>
              <br />
              <br />
            </template>
          </head-box>
          <br />
          <br/>
        </header>
        <main>

          <div id="temp">
            <!-- <span> -->
            <!-- <message-box v-if="noPath"></message-box> -->
            <box-grid ref="grid" v-bind:alg="algorithm"></box-grid>

            <!-- </span> -->
            <!-- <span> -->
            <content-box>
              <template v-slot:button>
                <div id="b">
                  <!-- <button class="button" v-on:click="$refs.grid.createGraph()" >Build </button> -->
                  <button
                    class="button"
                    v-on:click="
                      $refs.grid.createGraph();
                      draw();
                      hold = true;
                      b = 'viz'
                    "
                    v-bind:pathArr="path"
                  >Visualize</button>
                  <div id="distance">
                    <span>{{dist}}</span>
                    <label for>
                      <small>Distance</small>
                    </label>
                  </div>

                  <button
                    class="button"
                    v-on:click="$refs.grid.createGraph();
                      drawi();
                      hold = true;
                      b = 'ins'"
                  >Instant Path</button>
                </div>
              </template>
              <template v-slot:description>
                <p v-if="algorithm == 'Depth First Search'">This may or may not give the shortest path</p>
                <p v-else-if="algorithm == 'SELECT AN ALGORITHM'">SELECT an algorithm and press VISUALIZE</p>
                <p v-else>This gives the shortest path possible</p>
              </template>

              <template v-slot:controls>
                <div id="b">
                  <button class="button" v-on:click="$refs.grid.clearCanvas()">Clear Canvas</button>
                  <button class="button" v-on:click="$refs.grid.resetPointers()">Reset Pointers</button>
                  <button class="button" v-on:click="$refs.grid.clearPath()">Clear Path</button>
                </div>
              </template>
            </content-box>

            <!-- </span> -->
          </div>
          <br />
          <br />
        </main>
        <footer>
          <foot></foot>
        </footer>
      </div>
    </transition>
  </div>
</template>

<script>
import grid from "./components/grid";
import content from "./components/content";
import header from "./components/header";
import footer from "./components/footer";
import instructions from "./components/instructions"
import { bus } from "../src/main";
export default {
  components: {
    "box-grid": grid,
    "content-box": content,
    "head-box": header,
    "foot": footer,
    "tutorial": instructions
  },
  data() {
    return {
      path: null,
      dist: "∞",
      hold: false,
      count: 0, // change to 200 if bug detected
      algorithm: "SELECT AN ALGORITHM",
      noPath: true,
      visitedNodes: null,
      i: -1,
      b: null,
      end: false
      // instantB: false
      // rows: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
      // columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38],
      // sx: 11,
      // sy: 8,
      // dx: 11,
      // dy: 30,
    };
  },
  created() {
    bus.$on("stop", data => {
      this.path = data.p;
      this.dist = data.d;
      this.count = 0;
      this.hold = false;
      this.noPath = true;
      this.visitedNodes = null;
      this.i = -1;
      this.b = null;
    });
    bus.$on("visited", data => {
      this.visitedNodes = data;
    });
    // bus.$on("clear", data => {
    //   this.path = data.p;
    //   this.dist = data.d;
    //   // this.count = 0;
    //   // this.hold = false;
    //   // this.noPath = true;
    //   // this.visitedNodes = null;
    //   // this.i = -1;
    //   // this.b = null;
    // })
    bus.$on("end", data => {
      this.end = data;
    })

    this.interval = setInterval(() => this.draw(), 15);
    this.interval = setInterval(() => this.drawPath(), 20);
  },
  

  methods: {
    // endInst(data){
    //   if(data == 0){
    //     this.end = true;
    //   }
    // },
    drawPath() {
      if (
        this.algorithm == "Depth First Search" &&
        this.path != null &&
        this.i == this.visitedNodes.length
      ) {
        this.b = null;
        this.dist = this.path.length;
        if (this.count <= this.path.length) {
          if (
            document.getElementById(this.path[this.count].name).className !=
            "sd"
          ) {
            document.getElementById(this.path[this.count].name).className =
              "path";
          }else{
            document.getElementById(this.path[this.count].name).className = "src";
          }
          this.count++;
        }
      } else if(this.algorithm == "Breadth First Search" && this.path != null){
        this.b = null;
        if (this.count <= this.path.length) {
          if (
            document.getElementById(this.path[this.count].name).className !=
            "sd"
          ) {
            document.getElementById(this.path[this.count].name).className =
              "path";
          }else{
            document.getElementById(this.path[this.count].name).className = "src";

          }
          this.count++;
        }
      }else if(this.algorithm == "Bellman-Ford Algorithm"  && this.path != null){
        this.dist = this.path.length-1;
        this.b = null;
        // console.log("received");
        // console.log(this.path.length);
        // console.log(this.count);
        if (this.count < this.path.length) {
          if (document.getElementById(this.path[this.count].name).className != "sd") {
            // alert(this.path[this.count].name);
            document.getElementById(this.path[this.count].name).className = "path";
          }else{
            document.getElementById(this.path[this.count].name).className = "src";
          }
          this.count++;
        }
      }

      // }
    },
    drawi() {
      // let i = 0;
      
        if (this.algorithm == "Breadth First Search") {
          while (this.path == null) {
            this.$refs.grid.BFSsearch(false);
            // i ++;
            // if(i>800){
            //   if(this.path != null){
            //     this.noPath = false;
            //     break;
            //   }
            // }
          }
        }else if(this.algorithm == "Bellman-Ford Algorithm" && this.b == "ins"){
          for(let i= 0; i< 22*38 -1; i++){
            this.$refs.grid.bellmanFord();

          }
          
        }
        
        
      
    },
    draw() {
    if (this.algorithm == "Breadth First Search" && this.b == 'viz') {
      if (this.path == null) {
        this.$refs.grid.BFSsearch(true);
      }
    }
    else if (this.algorithm == "Depth First Search" && this.b != null) {
      let a = null;
      if (this.i == -1) {
        a = this.$refs.grid.DFS();
        this.path = a[0];
        this.visitedNodes = a[1];
        this.i++;
      } else {
        if(this.b == 'viz'){
          if (this.i < this.visitedNodes.length) {
            document.getElementById(this.visitedNodes[this.i]).className =
              "visited";
            this.i++;
  
          }

        }else{
          this.i = this.visitedNodes.length;
        }
      }

    }else if(this.algorithm == "Bellman-Ford Algorithm" && this.b == 'viz'){

          this.$refs.grid.bellmanFord();
          if(this.b == 'viz'){
            if(this.visitedNodes != null){
              for(let i = 0; i < 10; i++){
                document.getElementById(this.visitedNodes[this.i+1]).className = "visited";
                this.i++;
              }
              }

          }
          

        
      
      
    }
  }
  
          // i ++;
          // if(i>800){
          //   if(this.path != null){
          //     this.noPath = false;
          //     clearInterval(this.interval);

          //   }
          // }
          // }
        
     
  }
  // drag(){
  //   let s = document.getElementById(String(this.sx)+String("-")+String(this.sy));
  //   s.className = "unvisited";
  //   for (let i = 0; i <= 21; i++) {
  //     for (let j = 0; j <= 38; j++) {
  //       let id = document.getElementById(String(i) + String("-") + String(j));
  //       id.onmouseup = function drop(){
  //         id.className = "sd";
  //         var ar = id.id.split("-");
  //         this.sx = parseInt(ar[0]);
  //         this.sy = parseInt(ar[1]);
  //       }
  //     }
  //   }
  // },
  // update(){
  //   console.log("called");
  //   let s = document.getElementById(String(this.sx)+String("-")+String(this.sy));
  //   s.onmousedown
  //   return true;
  // // dispPath(event) {
  // //   this.path = event;
  // }
  // }
};
</script>

<style scoped>
.button {
  position: relative;

  width: 100px;
  height: 40px;
  font-size: 80%;
  border-radius: 2em;
  background-color: white;
  /* font-weight: bold; */
  font-family: "Source Sans Pro", sans-serif;
  color: #4fc08d;
  border: #4fc08d 1px solid;
  outline: none;
  margin: none;
  /* border: none; */
}
.button:hover {
  background-color: #4fc08d;
  border: #4fc08d;
  color: white;

  cursor: pointer;
}
#nc {
  position: relative;

  width: 100px;
  height: 50px;
  font-size: 80%;
  font-weight: bold;
  font-family: "Alef", sans-serif;
  color: rgba(171, 126, 223, 0.767);
  background-color: rgba(255, 255, 255, 0.767);
}
#c {
  position: relative;

  width: 100px;
  height: 50px;
  font-size: 80%;
  font-weight: bold;
  font-family: "Alef", sans-serif;
  color: rgba(171, 126, 223, 0.767);
  box-shadow: 0 0 50px black;
}

#b {
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* padding: 5px; */
  margin: 4px;
}
#temp {
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
p {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-size: 15px;
  color: white;
  outline: 2px;
  padding: 5px;
  color: gray;
  font-size: 20px;
  border-radius: 3px;
  /* font-family: 'Roboto Slab', serif; */
  font-family: "Source Sans Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
  font-weight: lighter;
  background-color: rgb(241, 240, 241);
}
#distance {
  position: relative;

  display: flex;
  width: 100px;
  height: 40px;
  flex-direction: column;
  border-radius: 2em;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #4fc08d;
  /* padding: 4px; */
  color: #f3eded;
  text-align: center;
  justify-content: center;
  font-family: "Source Sans Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
  background-color: #4fc08d;
}
::-webkit-scrollbar {
  width: 1px;
  height: 0px;
}
::-webkit-scrollbar-track {
  background: #ececf1;
}
::-webkit-scrollbar-thumb {
  background: rgba(165, 160, 160, 0.637);
}
#line {
  background: linear-gradient(90deg,rgb(95, 51, 136),#cefffd 40%,rgb(69, 133, 32));
  /* height: 0.5em; */
  padding: 0.2rem;
  margin-left: -10px;
  margin-right: -10px;
  margin-top: -10px;
  /* text-align: center; */
  /* color: #fff; */
  /* font-size: 1.5rem; */
}

.dropdown {
  /* -webkit-appearance: button;
  -moz-appearance: button;
  -webkit-user-select: none;
  -moz-user-select: none;
  -webkit-padding-end: 16px;
  -moz-padding-end: 20px;
  -webkit-padding-start: 6px;
  -moz-padding-start: 4px; */
  
  /* cursor: pointer; */
  background-color: rgb(
    255,
    255,
    255
  ); /* Fallback color if gradients are not supported */
  /* background-position: center right;
  background-repeat: no-repeat;
  border-radius: 2px;
  border: 1px gray;
  box-shadow: 0px 0px 1px rgba(255, 255, 255, 0.1);
  color: #666968;
  font-size: 15px; */

  font-family: "Source Sans Pro", sans-serif;
  margin: 0;
  /* overflow: hidden; */
  /* padding-top: 2px;
  padding-bottom: 2px; */
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  width: 220px;
  height: 35px;
  border: 1px solid #4fc08d;
  border-radius: 2em;
  outline: none;
}
select{
  border: 0;
  font: 16px "Source Sans Pro", sans-serif;
  
}

#bg-image {
  height: 1000px;
  width: 1373px;
  margin-left: -20px;
  /* margin-right: 0px; */
  background: url("../public/background.png");
  filter: blur(80px);
  /* background-position: center; */
  background-size: cover;
  background-repeat: no-repeat;
}

.fade-leave-active{
  transition: opacity 0.8s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-enter-active{
  transition: opacity 0.8s;
}
.fade-enter-to{
  opacity: 0;
}




</style>
